import type { InquiryFormTypes, SearchEstateParams } from './inquiryApiTypes';

const request = async (url: string, msg: string) => {
  const response = await fetch(url);
  if (!response.ok) {
    console.log('API Error : ', response.status);
    throw new Error(msg);
  }
  return response.json();
};

// 중개사무소 검색
export const searchEstateApi = async (params: SearchEstateParams) => {
  try {
    const searchParams = new URLSearchParams({
      keyword: params.keyword,
      page: String(params.page ?? 1),
      perPage: String(params.perPage ?? 50),
    });

    return await request(`/api/about/searchCompany?${searchParams.toString()}`, '중개사무소 검색 조회 실패');
  } catch (error) {
    console.log('Network Error : ', error);
    throw error;
  }
};

// 문의 작성
export const submitInquiryApi = async (params: InquiryFormTypes) => {
  try {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) {
        searchParams.append(key, String(value === null ? '' : value));
      }
    }

    return await request(`/api/about/inquiry?${searchParams.toString()}`, '문의 보내기 실패');
  } catch (error) {
    console.log('Network Error : ', error);
    throw error;
  }
};
